import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker,  Circle, ScaleControl} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import AssistanteToobib from './AssistanteToobib';
import '../css/Page_Principale.css'


//Ci-dessous on omporte tous les composants (fonctions) qui sont dans ./functions
import EtablissementsMarkers from './ES_Markers';
import PraticienMarkers from './PS_Markers';
import Modal_Remerciement from './Modal_Remerciement';
import Fenetre_Clusters_Rayon from './Fenetre_Clusters_Rayon';
import ModalModification from './ModalModification';
import MenuLateral from './MenuLateral';
import Bulles_Etablissements_Professionnels_Selectionnes from './Bulles_Etablissements_Professionnels_Selectionnes';
import TopBanner from './BannièreHaut';
import PopupJetonAcces from './PopUpJetonAcces';
import  {PanneauInfoSupplementairesEtablissement}  from './PanneauInfoSupplementairesEtablissement';
import { Telecharger_Rapport_PDF } from './Telecharger_Rapport_PDF';
import { Recuperer_adresse_avec_coord, Recuperer_coord_avec_adresse, handleUserCurrentLocation } from './Fonctions_Geolocalisation';
import { FitBounds, Recenter, RecenterModal } from './Fonctions_Cartographie';
import { fetchSousCategories, fetchData, fetchPraticiens } from './Fonctions_Communications_API';
import AjoutSiteWeb from './Ajout_Site_Web';
import ModalMigrationPraticien from "./Modal_Migration_Praticien";
import FenetreLimiteRequete from './FenetreLimiteRequete';
import ModalAjoutPraticien from './ModalAjoutPraticien';


import { useAuth } from '../AuthContext';
import ModalMessageSupport from './ModalMessageSupport';


function Page_Principale() {
    
    const { isAdmin } = useAuth();
    
    //Ces deux variables sont dédiées à la recherche de l'utilisateur
    const [coordonnéesPointCentral, setCoordonnéesPointCentral] = useState({ lat: 48.8589371652797 , lng: 2.2934405964663034 }); //Coordonées du point central 
    const [rayonDeRecherche, setRayonDeRecherche] = useState(1000); // Rayon du cercle de recherche
    const [afficherCercleDeRecherche, setAfficherCercleDeRecherche]=useState(true) //Pour désactiver le cercle lorsque l'on génère un pdf




    const [chargement, setChargement] = useState(true); // Pour l'écran de chargement au début (le petit rond qui tourne)























    //ICI ON GERE TOUT CE QUI ATTRAIT AUX CATEGORIES ET SOUS-CATEGORIES D'ETABLISSEMENTS DE SANTE AINSI QU'AUX PROFESSIONS DE SANTE

    //liste des professions à mettre en ligne 
    const professions = [
        'Acteur du système de santé caractérisé par un rôle','Anatomo-Cyto-Pathologiste','Anesthésiste réanimateur','Assistant social','Audio-Prothésiste','Cardiologue','Chiropracteur','Chirurgien dentiste et chirurgien oral','Chirurgien général', 'Chirurgien infantile', 'Chirurgien maxillo-facial et stomatologiste', 'Chirurgien orthopédiste et traumatologue', 'Chirurgien plasticien', 'Chirurgien thoracique et cardio-vasculaire','Chirurgien viscéral', 'Dermatologue et vénérologue','Diététicien', 'Endocrinologue-diabétologue','Epithésiste', 'Ergothérapeute', 'Gastro-entérologue et hépatologue','Gériatre','Gynécologue et obstétricien','Hématologue', 'Infirmier', 'Maladies infectieuses et tropicales','Masseur-kinésithérapeute','Médecin','Médecin allergologue','Médecin biologiste','Médecin généraliste','Médecin généticien',"Médecine d'urgence",'Médecine du travail','Médecine légale et expertises médicales','Médecine vasculaire','Médecin spécialiste en médecine nucléaire','Médecin spécialiste en santé publique et médecine sociale', 'Manipulateur ERM', 'Néphrologue', 'Neurochirurgien','Neurologue','Neuropsychiatre','Oculariste', 'Oncologue et radiothérapeute','Ophtalmologiste', 'Opticien-Lunetier','Orthopédiste-Orthésiste','Orthophoniste','Orthoprothésiste', 'Orthoptiste','Ostéopathe','Oto-Rhino-Laryngologue (ORL) et chirurgien cervico-facial', 'Pédiatre','Pédicure-podologue et Podo-Orthésiste','Pharmacien', 'Physicien médical','Pneumologue','Psychiatre','Psychologue','Psychomotricien','Psychothérapeute','Radiologue','Rhumatologue','Sage-femme','Spécialiste en médecine interne','Spécialiste en médecine physique et de réadaptation', 'Technicien de Laboratoire', 'Urologue & chirurgien urologue'
    ];
    const [sousCategories, setSousCategories] = useState([]); // La liste des différentes catégories d'établissements de santé
    const [dicoCategories, setDicoCategories] = useState({}); // Ce dictionnaire permet de stocker les sous-catégories associées à chaque catégorie


    //Les catégories et sous-catégories et professions séléctionnées par l'utilisateur
    const [selectedCategories, setSelectedCategories]=useState([])
    const [selectedSousCategories, setSelectedSousCategories] = useState([]); // Les catégories séléctionnées par l'utilisateur
    const [selectedProfessions, setSelectedProfessions] = useState([])
    

    
    useEffect(() => {
        fetchSousCategories(setDicoCategories, setSousCategories);
    }, []);
    
    useEffect(() => {
        if (Object.keys(dicoCategories).length > 0) {
            setChargement(false); 
        }
    }, [dicoCategories]);
    
    
    useEffect(()=>{
        if (selectedProfessions.length>0){
            setSelectedSousCategories([]);
        }
    }, [selectedProfessions])
    
    
    //Tant que les sous-catégories ne sont pas chargées, on affiche l'écran de chargement
    useEffect(()=>{
        if (sousCategories.length===0){
            setChargement(true)
        }
    }, [sousCategories.length])

    
    //Pour récupérer les logos
    const logoSousCategories = sousCategories





















    //ICI ON GERE LES RECHERCHES DE L'UTILISATEUR



    //Ces deux variables stockent les résultats de la recherche de l'utilisateur
    const [praticiensData, setPraticiensData] = useState([]); //Les données des praticiens de santé à afficher
    const [filteredData, setFilteredData] = useState([]); //Les données filtrées (celles dans le cercle de recherche) à afficher


    useEffect(() => {
        const fetchFilteredData = async () => {
            setChargement(true);
            setUtilisateurVeutModifier(false);
            try {
                await fetchData(coordonnéesPointCentral, rayonDeRecherche, selectedSousCategories, selectedCategories, setFilteredData, selectedProfessions, setPraticiensData);
                await fetchPraticiens(coordonnéesPointCentral, rayonDeRecherche, selectedProfessions, setPraticiensData);
            } catch (err) {
                console.error('Error fetching data:', err);
            } finally {
                setChargement(false);
            }
        };
        fetchFilteredData();
    }, [coordonnéesPointCentral, rayonDeRecherche, selectedCategories, selectedSousCategories, selectedProfessions]);











    

    const [isPhone, setIsPhone] = useState(window.innerWidth <= 750);
    const [showMenuLateral, setShowMenuLateral] = useState(true);

    useEffect(() => {
        const checkScreenSize = () => {
            const phoneStatus = window.innerWidth <= 750;
            setIsPhone(phoneStatus);
            
        };

        checkScreenSize(); // Ensure the correct state is set initially
        window.addEventListener('resize', checkScreenSize);
        
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    //const hasCheckedOnce = useRef(false);

    // useEffect(() => {
    //     const checkScreenSize = () => {
    //         const phoneStatus = window.innerWidth <= 750;
    //         setIsPhone(phoneStatus);
    //         if (phoneStatus && !hasCheckedOnce.current) {
    //             setShowMenuLateral(false);
    //             hasCheckedOnce.current = true;
    //         }
    //     };

    //     const timeout = setTimeout(() => {
    //         checkScreenSize();
    //     }, 100);

    //     window.addEventListener('resize', checkScreenSize);

    //     return () => {
    //         clearTimeout(timeout);
    //         window.removeEventListener('resize', checkScreenSize);
    //     };
    // }, []);



      console.log("afficher le panneau latéral:", showMenuLateral)
      console.log("Utilisateur sur téléphone :",isPhone)
    

    
    const [useFitBounds, setUseFitBounds] = useState(true); // Pour savoir si l'on adapte le zoom autour du cercle ou non 
    

    
   



    //ICI ON GERE QUAND L'UTILISATEUR VEUT RECHERCHER UNE ADRESSE


    //Cette variable stocke l'adresse que l'utilisateur entre dans le panneau latéral
    const [address, setAddress] = useState(''); 
    const [geocodeResults, setGeocodeResults] = useState([]);


      const handleSelectResult = (result) => {
        setUseFitBounds(false);
        setCoordonnéesPointCentral({ lat: result.coordinates[1], lng: result.coordinates[0] });
        setTimeout(() => {
          setUseFitBounds(true);
        }, 2500);
        setGeocodeResults([]); 
        setAddress(''); 
      };

      useEffect(() => {
        if (address.trim() === '') {
          setGeocodeResults([]); 
          return;
        }
        const debounceTimer = setTimeout(() => {
            Recuperer_coord_avec_adresse(address, setGeocodeResults);
        }, 300); 
    
        return () => clearTimeout(debounceTimer); 
      }, [address]);




    // Cette fonction rapide permet d'autoriser la touche "Entrée" au lieu du bouton "Rechercher"
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            Recuperer_coord_avec_adresse(address, setGeocodeResults);
        }
    };


    

    






    //ICI ON GERE LES BULLES EN BAS DE L'ECRAN QUI CONTIENNE LES SOUS-CATEGORIES ET PROFESSIONS SELECTIONNEES PAR L'UTILISATEUR

    

    const bubbleContainerRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);

    const handleRemoveSousCategory = (souscategoryToRemove, index) => {
    setSelectedSousCategories((prevSousCategories) =>
        prevSousCategories.filter((sous_category) => sous_category !== souscategoryToRemove)
    );
    setExpandedBubbles((prevExpandedBubbles) => {
        return prevExpandedBubbles.filter(c => c !== souscategoryToRemove);
      });
    };


  useEffect(() => {
    if (bubbleContainerRef.current) {
      
      bubbleContainerRef.current.scrollLeft = scrollPosition;
    }
    }, [scrollPosition]);

    

    function openURL(url) {
        window.open(url, "_blank");
    }


    

    const [expandedBubbles, setExpandedBubbles] = useState([]);
    
    
    const handleRemoveProfession = (professionToRemove, index) => {
        setSelectedProfessions((prevProfession) =>
            prevProfession.filter((prof) => prof !== professionToRemove)
        );
        setExpandedBubbles((prevExpandedBubbles) => {
            return prevExpandedBubbles.filter(c => c !== professionToRemove);
          });
        };


      










    //ICI ON GERE LA GENERATION DU PDF QUAND L'UTILISATEUR CLIQUE SUR LE BOUTON "Télécharger le PDF"  

      const telechargement_PDF = () => {
        setAfficherClusters(false);
        Telecharger_Rapport_PDF({
            coordonnéesPointCentral,
            setCoordonnéesPointCentral,
            setAfficherCercleDeRecherche,
            Recuperer_adresse_avec_coord,
            filteredData,
            selectedSousCategories,
            selectedProfessions,
            praticiensData,
        });
        setTimeout(()=>{
            setAfficherClusters(true);
        }, 1000 )
    };
    
    











    //ICI ON GERE LORSQU'UN UTILISATEUR VEUT MODIFIER LES INFORMATIONS D'UN ETABLISSEMENT

    

    const [utilisateurVeutModifier, setUtilisateurVeutModifier] = useState(false)
    const [emailsVerifies, setEmailVerifies] = useState([])
    const [email, setEmail] = useState("");
    const [modifPermise, setModifPermise] = useState(false);

    useEffect(()=>{
        emailsVerifies.includes(email) ? setModifPermise(true) : setModifPermise(false);
    }, [emailsVerifies, email, utilisateurVeutModifier])


    //Pour rappatrier les emails qui ont été vérifiées
    useEffect(() => {
        let intervalle_de_recuperation_emails_verifies;
        const fetchEmails = async () => {
            try {
                const response = await fetch("https://carto.api.toobib.org/api/get_verified_emails");
    
                if (!response.ok) {
                    throw new Error("Failed to fetch verified emails");
                }
    
                const data = await response.json(); 
                setEmailVerifies(data);
            } catch (error) {
                console.error("Error fetching verified emails:", error);
            }
        };
        if (utilisateurVeutModifier) {
            intervalle_de_recuperation_emails_verifies = setInterval(fetchEmails, 2000);
            fetchEmails(); 
        }
        return () => {
            if (intervalle_de_recuperation_emails_verifies) {
                clearInterval(intervalle_de_recuperation_emails_verifies);
            }
        };
    }, [utilisateurVeutModifier]);
    
    
    
    const [ouvrirFenetreModifications, setOuvrirFenetreModifications]=useState(false)
    const [establishment_to_modify, setEstablishmentToModify]=useState({}) //les informations de l'établissement à modifier



    const [showThankYouModal, setShowThankYouModal]=useState(false)

    //Pour rendre le marqueur de position de l'utilisateur "draggable"
    const updatePosition = (event) => {
        const marker = event.target;
        const newPosition = marker.getLatLng();
        setCoordonnéesPointCentral({ lat: newPosition.lat, lng: newPosition.lng });
      };




    //Ce petit bout de code pour savoir si l'utilisateur est sur téléphone ou pc  
    
    



      // Ce code permet de gérer l'ouverture de la fenêtre en haut de l'écran qui permet de désactiver les clusters et modifier le rayon de la recherche

      const [circleClicked, setCircleClicked] = useState(false)
      const [afficherClusters, setAfficherClusters]=useState(true)
     



      //Pour afficher la bannière en haut de l'écran
      const [afficherBanniere, setAfficherBanniere] = useState(false)



      //Pour afficher le panneau des informations supplémentaires à gauche
      const [afficherPanneauInfoSupplementaires, setAfficherPanneauInfoSupplementaires] = useState(false)



      //Garder en paramètre le numero de finess de l'établissement cliqué
	  const [numeroFiness, setNumeroFiness] = useState(null)
	  








    //ICI ON GERE LA PARTIE ADMINISTRATEUR

    const [afficherPopupAdmin, setAfficherPopupAdmin]=useState(false)
    const Naviguer_Vers_Fenetre_Validation_Modifications = () => {
        const url = `${window.location.origin}/validation_modification`; 
        window.open(url, "_blank"); 
    };

    const Naviguer_Vers_Fenetre_SQL = () => {
        const url = `${window.location.origin}/SQL`; 
        window.open(url, "_blank"); 
    };









    const [afficherPopupSiteWeb, setAfficherPopupSiteWeb] = useState(false); // Ouvrir le pop d'up d'ajout de site web
    const [selectedEstablishment, setSelectedEstablishment] = useState(null); 


    const [afficherModalMigrationPraticiens, setAfficherModalMigrationsPraticiens] = useState(false); // Ouvrir le pop d'up de migration d'un praticien
    const [praticienAMigrer, setPraticienAMigrer] = useState(null); // ID du praticien à migrer
    const [establishmentDepuisLequelLePraticienMigre, setEstablishmentDepuisLequelLePraticienMigre] = useState(null); // Etablissement du praticien à migrer
    const [afficherModalAjoutPraticien, setAfficherModalAjoutPraticien] = useState(false); // Ouvrir le pop d'up d'ajout de praticien







    const [afficherEtatModifications, setAfficherEtatModifications] = useState(false); 




    //POUR SAVOIR SI L'UTILISATEUR VEUT ENVOYER UN MESSAGE AU SUPPORT
    const [ouvrirModalEnvoyerMessageSupport, setOuvrirModalEnvoyerMessageSupport]=useState(false)
    
    return (
        <div className="conteneur_principal">
            {chargement && (
                <div className="chargement">
                    <div className="cercle-qui-tourne-vite"></div>
                </div>
            )} 
        <ModalMessageSupport ouvrir={ouvrirModalEnvoyerMessageSupport} setOuvrir={setOuvrirModalEnvoyerMessageSupport}/>
        <FenetreLimiteRequete donneesFiltrees={filteredData} selectedProfessions={selectedProfessions} selectedSousCategories={selectedSousCategories}/>
        <AssistanteToobib utilisateurSurTelephone={isPhone} />
        <Bulles_Etablissements_Professionnels_Selectionnes
                selectedSousCategories={selectedSousCategories}
                selectedProfessions={selectedProfessions}
                expandedBubbles={expandedBubbles}
                showMenuLateral={showMenuLateral}
                bubbleContainerRef={bubbleContainerRef}
                handleRemoveSousCategory={handleRemoveSousCategory}
                handleRemoveProfession={handleRemoveProfession}
                setScrollPosition={setScrollPosition}
                setExpandedBubbles={setExpandedBubbles}
            />

            <button
            className="bouton_pour_afficher_le_panneau_lateral"
            title="Ouvrir/Fermer le menu latéral"
            onClick={() => {
                setShowMenuLateral(!showMenuLateral);
            }}
            
            style={{top:!showMenuLateral && afficherBanniere ? '75px' : '10px'}}
            >
            <img style={{width: "auto", height: "auto",maxWidth: '75%',maxHeight: '75%'}} src={showMenuLateral ? "carte.png" : "menu_lateral.png"} alt="Right Arrow" />
            </button>
            <button title="CGU, Mentions légales ..." onClick={()=>setAfficherBanniere(!afficherBanniere)} className="bouton_pour_ouvrir_la_banniere" style={{top:!showMenuLateral && afficherBanniere ? '75px' : '10px'}}>
                <img style={{width: "auto", height: "auto",maxWidth: '75%',maxHeight: '75%'}} src="bouton-informations.png" alt="Right Arrow" />
            </button>
            <button title="Contacter le support" onClick={()=>setOuvrirModalEnvoyerMessageSupport(true)} className="bouton_pour_ouvrir_le_modal_envoyer_message_support" style={{top:!showMenuLateral && afficherBanniere ? '75px' : '10px'}}>
                <img style={{width: "auto", height: "auto",maxWidth: '75%',maxHeight: '75%'}} src="service-client.png" alt="Right Arrow" />
            </button>
            {!isPhone && (
                <>
            {!isAdmin ? (
                <button title="Mode administrateur" onClick={()=>setAfficherPopupAdmin(!afficherPopupAdmin)} className="bouton_pour_acceder_au_mode_admin" style={{top:!showMenuLateral && afficherBanniere ? '75px' : '10px'}}>
                    <img style={{width: "auto", height: "auto",maxWidth: '75%',maxHeight: '75%'}} src="cadenas.png" alt="Right Arrow" />
                </button>
            ):(
            <button title="Valider des modifications" onClick={Naviguer_Vers_Fenetre_Validation_Modifications} className="bouton_pour_acceder_aux_validations" style={{top:!showMenuLateral && afficherBanniere ? '75px' : '10px'}}>
                <img style={{width: "auto", height: "auto",maxWidth: '75%',maxHeight: '75%'}} src="validation.png" alt="Right Arrow" />
            </button>
            )}
            {isAdmin && !isPhone &&(
                <button title="SQLhub" onClick={Naviguer_Vers_Fenetre_SQL} className="bouton_pour_acceder_à_editeur_sql" style={{top:!showMenuLateral && afficherBanniere ? '75px' : '10px'}}>
                    <img style={{width: "auto", height: "auto",maxWidth: '75%',maxHeight: '75%'}} src="SQL.png" alt="Right Arrow" />
                </button>
            )}
            </>
        )}
            <TopBanner
                afficherBanniere={afficherBanniere} filteredData={filteredData} praticiensData={praticiensData}/>

            <PanneauInfoSupplementairesEtablissement
            afficherPanneauInfoSupplementaires={afficherPanneauInfoSupplementaires}
            setAfficherPanneauInfoSupplementaires={setAfficherPanneauInfoSupplementaires}
			numeroFiness={numeroFiness}
            setShowThankYouModal={setShowThankYouModal}
			/>


            <MenuLateral
                showMenuLateral={showMenuLateral}
                isPhone={isPhone}
                telechargement_PDF={telechargement_PDF}
                
                
                rayonDeRecherche={rayonDeRecherche}
                setRayonDeRecherche={setRayonDeRecherche}
                address={address}
                setAddress={setAddress}
                handleKeyDown={handleKeyDown}
                geocodeResults={geocodeResults}
                handleSelectResult={handleSelectResult}
                handleUserCurrentLocation={handleUserCurrentLocation}
                
                
                selectedSousCategories={selectedSousCategories}

                setSelectedSousCategories={setSelectedSousCategories} 
                setSelectedProfessions={setSelectedProfessions}
                setSelectedCategories={setSelectedCategories}


                sousCategories={sousCategories}

                dicoCategories={dicoCategories}
                selectedCategories={selectedCategories}
                
                professions={professions}
                selectedProfessions={selectedProfessions}
                setUseFitBounds={setUseFitBounds}
                setCoordonnéesPointCentral={setCoordonnéesPointCentral}
            />
            <ModalModification
                ouvrirFenetreModifications={ouvrirFenetreModifications}
                setOuvrirFenetreModifications={setOuvrirFenetreModifications}
                establishment_to_modify={establishment_to_modify}
                setEstablishmentToModify={setEstablishmentToModify}
                sousCategories={sousCategories}
                email={email}
                RecenterModal={RecenterModal} 
                setShowThankYouModal={setShowThankYouModal}
            />
            <Modal_Remerciement
                show={showThankYouModal}
                onClose={() => setShowThankYouModal(false)}
            />
            <PopupJetonAcces
                afficherPopupAdmin={afficherPopupAdmin}
                setAfficherPopupAdmin={setAfficherPopupAdmin}
                />

            
            <AjoutSiteWeb afficherPopupSiteWeb={afficherPopupSiteWeb} setAfficherPopupSiteWeb={setAfficherPopupSiteWeb} establishment={selectedEstablishment}/>
            <ModalMigrationPraticien etablissement={establishmentDepuisLequelLePraticienMigre} personne={praticienAMigrer} afficherModalMigrationPraticiens={afficherModalMigrationPraticiens} setAfficherModalMigrationsPraticiens={setAfficherModalMigrationsPraticiens}/>
            <ModalAjoutPraticien etablissement={establishmentDepuisLequelLePraticienMigre} afficherModalAjoutPraticien={afficherModalAjoutPraticien} setAfficherModalAjoutPraticien={setAfficherModalAjoutPraticien} setShowThankYouModal={setShowThankYouModal}/>

            <Fenetre_Clusters_Rayon
                circleClicked={circleClicked}
                setCircleClicked={setCircleClicked}
                rayonDeRecherche={rayonDeRecherche}
                setRayonDeRecherche={setRayonDeRecherche}
                afficherClusters={afficherClusters}
                setAfficherClusters={setAfficherClusters}
                afficherEtatModifications={afficherEtatModifications}
                setAfficherEtatModifications={setAfficherEtatModifications}
                filteredData={filteredData}
            />
             
            <MapContainer
                
                center={[coordonnéesPointCentral.lat, coordonnéesPointCentral.lng]}
                zoom={10}
                style={{ height: '100vh', width: '100%' }}
                
            >
                
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                />
                <Recenter coordonnéesPointCentral={coordonnéesPointCentral} showMenuLateral={showMenuLateral} isPhone={isPhone}/>
                <FitBounds center={coordonnéesPointCentral} rayonDeRecherche={rayonDeRecherche} active={useFitBounds} />
                
                <ScaleControl position="bottomleft" />
                {afficherCercleDeRecherche && (
                <Circle 
                    center={[coordonnéesPointCentral.lat, coordonnéesPointCentral.lng]} 
                    radius={rayonDeRecherche} 
                    eventHandlers={{
                        click: ()=>!isPhone ? setCircleClicked(!circleClicked) : setCircleClicked(false)
                      }}
                    pathOptions={{
                        color: "#190b34", 
                        fillOpacity: 0, 
                        dashArray: '5 10', 
                        weight: !circleClicked ? 2.3 : 5,
                    }} 
                    
                />
            )}
                <Marker
                    position={coordonnéesPointCentral}
                    draggable={true}
                    eventHandlers={{
                    dragend: updatePosition,
                    }}
                    icon={L.icon({
                        iconUrl: 'epingle.png', 
                        iconSize: [35, 35],
                        iconAnchor: [17.5, 35], 
                        popupAnchor: [0, -35], 
                        shadowUrl: 'epingle_shadow.png', 
                        shadowSize: [41, 41], 
                    })}>
                        
                </Marker>
               
                                
                <EtablissementsMarkers
                    filteredData={filteredData}
                    selectedSousCategories={selectedSousCategories}
                    selectedCategories={selectedCategories}
                    logoSousCategories={logoSousCategories}
                    expandedBubbles={expandedBubbles}
                    utilisateurVeutModifier={utilisateurVeutModifier}
                    setUtilisateurVeutModifier={setUtilisateurVeutModifier}
                    email={email}
                    setEmail={setEmail}
                    modifPermise={modifPermise}
                    showMenuLateral={showMenuLateral}
                    setShowMenuLateral={setShowMenuLateral}
                    setOuvrirFenetreModifications={setOuvrirFenetreModifications}
                    setEstablishmentToModify={setEstablishmentToModify}
                    openURL={openURL}
                    coordonnéesPointCentral={coordonnéesPointCentral}
                    afficherClusters={afficherClusters}
                    afficherPanneauInfoSupplementaires={afficherPanneauInfoSupplementaires}
                    setAfficherPanneauInfoSupplementaires={setAfficherPanneauInfoSupplementaires}
					setNumeroFiness={setNumeroFiness}
                    isPhone={isPhone}
                    afficherPopupSiteWeb={afficherPopupSiteWeb}
                    setAfficherPopupSiteWeb={setAfficherPopupSiteWeb}
                    setSelectedEstablishment={setSelectedEstablishment}
                    selectedEstablishment={selectedEstablishment}
                    afficherModalMigrationPraticiens={afficherModalMigrationPraticiens}
                    setAfficherModalMigrationsPraticiens={setAfficherModalMigrationsPraticiens}
                    afficherModalAjoutPraticien={afficherModalAjoutPraticien}
                    setAfficherModalAjoutPraticien={setAfficherModalAjoutPraticien}
                    establishmentDepuisLequelLePraticienMigre={establishmentDepuisLequelLePraticienMigre}
                    setPraticienAMigrer={setPraticienAMigrer}
                    setEstablishmentDepuisLequelLePraticienMigre={setEstablishmentDepuisLequelLePraticienMigre}
                    afficherEtatModifications={afficherEtatModifications}
                    showThankYouModal={showThankYouModal}
                    />

                <PraticienMarkers
                    praticiensData={praticiensData}
                    coordonnéesPointCentral={coordonnéesPointCentral}
                    afficherClusters={afficherClusters}
                />
            </MapContainer>
                    </div>
    );
}

export default Page_Principale;

